import React from "react";
import GridItem from "../../../../ui/layout/page/grid-item";
import CustomTypography from "../../../../ui/widgets/typography";
import "./styles.scss";
import { Product } from "../../../../context/product-context/product";

interface ProductFamilyOptionProps {
  defaultProductForFamily: Product;
  renderProductFamilyImage: () => React.JSX.Element;
  productFamilyDescription: string;
  handleOnProductFamilySelection: (product: Product) => void;
  handleDialogClose: () => void;
}

const productFamilyBaseClass = "product-family";

const ProductFamilyOption: React.FC<ProductFamilyOptionProps> = ({
  defaultProductForFamily,
  renderProductFamilyImage,
  productFamilyDescription,
  handleOnProductFamilySelection,
  handleDialogClose,
}: ProductFamilyOptionProps) => (
  <GridItem container className={productFamilyBaseClass} size={{ md: 6 }}>
    <div
      data-testid={"product-family-container-" + defaultProductForFamily}
      className={`${productFamilyBaseClass}-container`}
      onClick={(): void => {
        handleOnProductFamilySelection(defaultProductForFamily);
        handleDialogClose();
      }}
    >
      <div className={`${productFamilyBaseClass}-image`}>
        {renderProductFamilyImage()}
      </div>

      <CustomTypography
        variant="subtitle1"
        className={`${productFamilyBaseClass}-description`}
      >
        {productFamilyDescription}
      </CustomTypography>
    </div>
  </GridItem>
);

export default ProductFamilyOption;
